<script>
import Layout from "../../../../layouts/manage";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Button from "@/components/c-button";
import Input from "@/components/c-input";
import Loading from "@/components/c-loading";
import Screen from "../../../../../components/screen";
import i18n from "../../../../../i18n";
import { expenseCategoryService } from "../../../../../services/managements/expenses/expensecategory.service";

/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  extends: Screen,
  page: {
    title: "Rent Status",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { 
    Layout, 
    PageHeader, 
    Loading,
    Button,
    Input,
  },
  data() {
    return {
      isAdd: true,
      fetchingStats: false,
      tryingToSubmit: false,
      title: "Rent Status",
      breadCrumb: {},

      type: {},
      valueId: 0,
      valueName: '',
      valueNameEn: '',
    };
  },
  mounted() {

    let hasId = 'id' in this.$route.params;
    this.isAdd = this.fetchingStats = !hasId;
    if(hasId) {
      this.loadingData(this.$route.params.id);     

    } 
  },

  methods: {

    loadingData: function(id) {
      this.fetchingStats = false;
      expenseCategoryService.getOne(id)
        .then(response => {
          
          this.fetchingStats = true;
          this.type = response.data;

          this.breadCrumb = {
            text: response.data.name,
            active: true,
          };

          this.valueId = this.type.id;
          this.valueName = this.type.name;
          this.valueNameEn = this.type.name_en;
        });
    },

    submitSave: function() {
      
      this.tryingToSubmit = true;

      let type = {
        name: this.valueName,
        name_en: this.valueNameEn,
      };

      console.log(JSON.stringify(type))

      if(this.isAdd) {
        expenseCategoryService.insert(type).then(response => {
          this.tryingToSubmit = false;
          if(response.status == 200) {
            this.clearForm();
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "manage-expense-category"
                });
              } 
            });
          }
        });
      } else {
        expenseCategoryService.update(this.$route.params.id, type).then(response => {
          this.tryingToSubmit = false;
          if(response.status == 200) {
            
            this.$swal.fire({
              title: i18n.t('general.success.title'),
              text: i18n.t('general.success.message'),
              icon: "success",
              showCancelButton: true,
              confirmButtonColor: "#34c38f",
              cancelButtonColor: "#f46a6a",
              confirmButtonText: i18n.t('general.success.yes'),
              cancelButtonText: i18n.t('general.success.no')
            }).then(result => {
              if (!result.value) {
                this.$router.push(this.$route.query.redirectFrom || {
                  name: "manage-expense-category"
                });
              } 
            });

          }
        });
      }

    },
    clearForm: function() {
      this.valueName = '';
      this.valueNameEn = '';
    }

  }
};
</script>

<template>
  <Layout>
    <!-- <PageHeader :items="['']" :title="$t('setting.configuration.loan-template.text')" /> -->
    <div v-if="this.isAdd">
      <PageHeader :items="[{
        text: $t('manage.expense-category.text'),
        href: '/manage/expense-category',
      }, {
        text: this.isAdd ? $t('manage.expense-category.new') : $t('manage.expense-category.edit'),
        active: true
      }]" :title="this.isAdd ? $t('manage.expense-category.new') : $t('manage.expense-category.edit')" />
    </div>
    <div v-else>
      <PageHeader :items="[{
        text: $t('manage.expense-category.text'),
        href: '/manage/expense-category',
      }, this.breadCrumb]" :title="this.isAdd ? $t('manage.expense-category.new') : $t('manage.expense-category.edit')" />
    </div>
    <Loading :loaded="fetchingStats" />
    <b-form v-show="fetchingStats" @submit.prevent="submitSave" class="row">
    
      <div class="col-lg-10">
        <div class="card">
          <div class="card-body">
              <div class="row">
                
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'name'"
                    v-model="valueName"
                    :require="true"
                    :label="'manage.expense-category.name'"  />
                </div>
                <div class="col-md-4">
                  <Input 
                    :type="'text'"
                    :id="'name_en'"
                    v-model="valueNameEn"
                    :require="true"
                    :label="'manage.name_en'"  />
                </div>
                
              </div>


              <div class="row">
                <div class="col-lg-12">

                  <div inline class="row gy-2 gx-3 align-items-end">
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-x-circle'" 
                        v-bind:buttonType="'button'"
                        v-bind:variant="'danger'"
                        @click="submitCancel()"
                        v-bind:title="$t('general.cancel')"  />
                    </div>
                    <div class="col-sm-auto">
                      <Button v-bind:icon="'bx bx-save bx-tada'" 
                        v-bind:buttonType="'button'"
                        @click="submitSave()"
                        v-bind:requesting="tryingToSubmit"
                        v-bind:title="$t('general.save')"  />
                    </div>
                  </div>
    
                </div>
              </div>
          
          </div>
        </div>
      </div>
    </b-form> 
  </Layout>
</template>